// Player da "Palavra do padre". Links do YouTube viram iframe (sem cookies);
// qualquer outro https vira <video>. Nunca toca sozinho.
// Vídeos verticais (shorts e arquivos em pé) cabem na altura da tela (62vh),
// com a largura seguindo a proporção 9:16, sempre centralizados.
function youtubeId(url: string): { id: string; shorts: boolean } | null {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') {
      const id = u.pathname.replace(/^\/+/, '');
      return id ? { id, shorts: false } : null;
    }
    if (host === 'youtube.com' || host === 'youtube-nocookie.com' || host.endsWith('.youtube.com')) {
      if (u.pathname === '/watch') {
        const id = u.searchParams.get('v');
        return id ? { id, shorts: false } : null;
      }
      const m = u.pathname.match(/^\/(shorts|embed)\/([^/]+)/);
      if (m) return { id: m[2], shorts: m[1] === 'shorts' };
    }
  } catch {
    /* não é uma URL válida */
  }
  return null;
}

export default function PlayerPadre({ url }: { url: string }) {
  const yt = youtubeId(url);
  const vertical = yt?.shorts === true;

  return (
    <div
      className="mx-auto w-full overflow-hidden rounded-[20px] border border-[rgba(217,178,95,.25)] bg-black"
      style={{ maxWidth: vertical ? undefined : 560 }}
    >
      {yt ? (
        vertical ? (
          <div
            className="mx-auto"
            style={{ height: '62vh', aspectRatio: '9 / 16', maxWidth: '100%' }}
          >
            <iframe
              className="h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${yt.id}?playsinline=1&rel=0`}
              title="Vídeo: palavra do padre"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        ) : (
          <div className="aspect-video">
            <iframe
              className="h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${yt.id}?playsinline=1&rel=0`}
              title="Vídeo: palavra do padre"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        )
      ) : (
        <video
          className="mx-auto block"
          controls
          playsInline
          preload="metadata"
          src={`${url}#t=0.1`}
          style={{ maxHeight: '62vh', maxWidth: '100%' }}
        />
      )}
    </div>
  );
}